import React, { useEffect, useState } from "react";
import Navbar from "../components/header/Navbar";
import Footer from "../components/header/Footer";
// Layout Component
const Layout = ({ children }) => {
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        // Scrolling down → hide navbar
        setShowNavbar(false);
      } else {
        // Scrolling up → show navbar
        setShowNavbar(true);
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);
  return (
    <div>
      {/* Fixed Navbar */}
      <div
        className={`fixed top-0 left-0 w-full z-50 transition-transform duration-300 ${
          showNavbar ? "translate-y-0" : "-translate-y-full"
        } text-white font-[Roboto] bg-opacity-10`}
      >
        <Navbar />
      </div>

      {/* Content Below Navbar */}
      <div className="">{children}</div>
      {/* mt-24 is to make space for the fixed navbar */}
      <Footer />
    </div>
  );
};

export default Layout;
